import { BundleOfferPackageOptionView } from 'selectors/offerPage/bundledOfferPageSelectors'
import { sortBy } from 'lib/array/arrayUtils'

interface Props {
  filteredBundlePackageId?: string
  packageOptions: { [bundlePackageId: string]: BundleOfferPackageOptionView }
  bundledPackages: { [bundlePackageId: string]: Array<App.Package> }
  fetching?: boolean;
  availableForPurchase: boolean;
}

export function buildBundlePackagesViewOrder({ packageOptions, bundledPackages, filteredBundlePackageId, fetching, availableForPurchase }: Props) {
  const availablePackageOptionsKeys = Object.keys(bundledPackages).filter((bundlePackageId) => bundledPackages[bundlePackageId]?.length > 0)

  return sortBy(availablePackageOptionsKeys, (bundlePackageId) => {
    const packageView = packageOptions[bundlePackageId]
    const canPurchase = availableForPurchase && packageView.capacityValid && packageView.hotelAvailable && !fetching
    const selected = filteredBundlePackageId ? bundlePackageId === filteredBundlePackageId : true

    const totalPrice = packageView.hotelPrice + (packageView.surcharge ?? 0)

    if (canPurchase) {
      return totalPrice - 100 - (selected ? 100 : 0)
    }

    return Number.MAX_SAFE_INTEGER
  }, 'asc')
}
